import { Stack, useTheme } from "@mui/material";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { KnowledgePaths } from "routes/KnowledgeRouter";
import { useCardContext } from "../../CardBuilder";
import { StickerBox } from "../common/StickerBox";
import { DefaultContent } from "./defaults";


export const PublicationAdminTitle = () => {
    const { pub } = useCardContext();
    const theme = useTheme();
    const { t } = useTranslation("knowledge");

    const isBlocked = pub.blocked?.blockedOn != undefined;

    return (
        <div>
            <Link to={KnowledgePaths.PublicationViewerResolver(pub.publicationId, pub.publicationType, pub.masterPublication?.publicationId)}>
                <MprcFeedTypography variant="title" component="div" color={isBlocked ? "warning" : undefined}>
                    <span title={pub.title}>{pub.title}</span>
                </MprcFeedTypography>
            </Link>
            <Stack spacing={0.5} alignItems="flex-end" direction="row">
                {pub.sticker && <StickerBox name={pub.sticker.name} textColor={pub.sticker.textColor} backgroundColor={pub.sticker.backgroundColor} />}
                {isBlocked && <StickerBox name={t("Feed.Card.Common.BlockedText")} textColor={theme.palette.common.white} backgroundColor={theme.palette.warning.main} />}
            </Stack>
        </div>
    );
};

export const PublicationAdminContent = () => {
    const { localContent } = useCardContext();
    return localContent.state == "expanded" ? <DefaultContent /> : <></>;
};
